import React, { useState } from 'react';
import { withRouter } from 'react-router';
import { useSnackbar } from 'notistack';
import { Paper, Grid, Accordion, AccordionSummary, AccordionDetails, TextField, Tooltip, Button } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { CkEditorText, DeletePopUp, PageLoader } from '../../../shared_elements';
import AddSection from './AddSection';
import SortSections from './SortSections';
import { castleAirInstance } from '../../../shared_elements/components';
const SectionCheckList = ({ sectionData, setSectionData, onToggleSection, sectionObj }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [deleteSection, setDeleteSection] = useState({ modal: false, type: '', data: null })

    const onAddSection = (title, value, parentIndex = null) => {
        if (!title.trim()) {
            enqueueSnackbar('Please enter Name', { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
            return;
        }
        if (parentIndex !== null && parentIndex !== undefined) {
            setSectionData(prev => prev.map((section, index) => index === parentIndex ? { ...section, sub_sections: [...(section.sub_sections || []), { title, value }] } : section));
        } else {
            setSectionData(prev => [...prev, { title, value, value_type: 1, sub_sections: [] }]);
        }
        onToggleSection(false);
    };

    const onFieldChange = (key, value, sectionIndex, subIndex = null) => {
        const finalValue =
            key === "value"
                ? (value && value !== "<p>1.&nbsp;</p>" ? value : "")
                : value;

        setSectionData(prev =>
            prev.map((section, sIndex) => {
                if (sIndex !== sectionIndex) return section;

                if (subIndex !== null) {
                    return {
                        ...section,
                        sub_sections: section.sub_sections.map((sub, subI) =>
                            subI === subIndex
                                ? { ...sub, [key]: finalValue }
                                : sub
                        )
                    };
                }

                return {
                    ...section,
                    [key]: finalValue
                };
            })
        );
    };


    const handleDeleteSection = () => {
        const { sectionIndex, subIndex } = deleteSection?.data || {};
        if (subIndex !== null && subIndex !== undefined) {
            setSectionData(prev => prev.map((section, index) => index === sectionIndex ? { ...section, sub_sections: section.sub_sections.filter((_, i) => i !== subIndex) } : section));
        } else {
            setSectionData(prev => prev.filter((_, index) => index !== sectionIndex));
        }
        setDeleteSection({ modal: false, type: null, data: null });
    };
    const handleChange = (panel, isExpanded) => { setExpanded(isExpanded ? panel : false); };
    return (
        <section className='project-forms-section' style={{ margin: "0px" }}>
            <div className='observations-form'>
                <div className='t004-content-sections'>
                    <>
                        <div className='content-sections-hd'>
                            <Grid container spacing={1}>
                                <Grid item md={6}>
                                    <ul className='list-inline'>
                                        <li className='list-inline-item'>
                                            <Button onClick={() => onToggleSection(true)} color='primary' size='small' variant='contained'>Add Section</Button>
                                        </li>
                                    </ul>
                                </Grid>
                                <Grid item md={6}>
                                    <ul className='list-inline' style={{ float: 'right' }}>
                                        {sectionData?.length > 1 ?
                                            <li className='list-inline-item'>
                                                <SortSections
                                                    toolTipContent='Sort Sections'
                                                    assetSections={sectionData}
                                                    getResponseBack={(sortedSections) => {
                                                        setSectionData(sortedSections);
                                                      }}
                                                />
                                            </li> : null
                                        }
                                    </ul>
                                </Grid>
                            </Grid>
                        </div>
                        {sectionData?.map((section, sectionIndex) =>
                        <div   style={{ cursor: castleAirInstance && section?.reference_id ? "not-allowed" : "pointer" }}>
                                <Accordion square key={sectionIndex} expanded={!(castleAirInstance && section?.reference_id) &&  expanded === `section_${sectionIndex}`} onClick={(event) => handleChange(`section_${sectionIndex}`, expanded === `section_${sectionIndex}` ? false : true)} >
                                <AccordionSummary
                                    expandIcon={(castleAirInstance && section?.reference_id) ? null :<ExpandMoreIcon />}
                                    id={`panel1bh-header_${sectionIndex}`}
                                    style={{ cursor: castleAirInstance && section?.reference_id ? "not-allowed" : "pointer" }}
                                >
                                    <Grid container spacing={1} alignItems='center'>
                                        <Grid item md={10}  style={{ cursor: castleAirInstance && section?.reference_id ? "not-allowed" : "pointer" }}>
                                            <div className='section-title-field' onClick={(e) => { e.preventDefault(); e.stopPropagation() }}>
                                                <TextField
                                                    id={`section_name_${section.id}`}
                                                    placeholder='Type Section Name'
                                                    fullWidth
                                                    margin="none"
                                                    InputLabelProps={{ shrink: true }}
                                                    value={section.title}
                                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange('title', e.target.value, sectionIndex) }}
                                                    onFocus={(e) => { e.preventDefault(); e.stopPropagation(); }}
                                                    variant='outlined'
                                                    disabled={castleAirInstance && section?.reference_id }
                                                    style={{
                                                        cursor: castleAirInstance && section?.reference_id ? "not-allowed" : "text",
                                                      }}
                                                />
                                            </div>
                                        </Grid>
                                        {castleAirInstance && section?.reference_id ? null :   <Grid item md={2} onClick={(e) => e.stopPropagation()}>
                                            <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                                                <li className='list-inline-item'>
                                                    <Tooltip title='Delete Section' arrow>
                                                        <DeleteOutlineIcon onClick={(e) => { e.preventDefault(); e.stopPropagation(); setDeleteSection({ modal: true, type: 'Section', data: { sectionIndex: sectionIndex } }) }} color='secondary' fontSize='medium' />
                                                    </Tooltip>
                                                </li>
                                            </ul>
                                        </Grid>}
                                      
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className='section-content' onClick={(e) => { e.preventDefault(); e.stopPropagation() }}>
                                        <div>
                                           <CkEditorText
                                                htmlData={section.value}
                                                onChangeData={(data) => onFieldChange('value', data, sectionIndex)}
                                            />
                                        </div>
                                        <Paper className='sub-sections-content'>
                                            <Grid container spacing={1}>
                                                <Grid item md={6}>
                                                    <ul className='list-inline'>
                                                        <li className='list-inline-item'>
                                                            <Button onClick={() => onToggleSection(true, sectionIndex)} color='primary' size='small' variant='contained'>Add Sub Section</Button>
                                                        </li>
                                                    </ul>
                                                </Grid>
                                                <Grid item md={6}>
                                                    <ul className='list-inline' style={{ float: 'right' }}>
                                                        {section.sub_sections.length && section.sub_sections.length > 1 ?
                                                            <SortSections
                                                                toolTipContent='Sort Sub-Sections'
                                                                assetSections={section.sub_sections}
                                                                getResponseBack={(sortedSubSections) => {
                                                                    setSectionData(prev =>
                                                                      prev.map((sec, i) =>
                                                                        i === sectionIndex
                                                                          ? {
                                                                              ...sec,
                                                                              sub_sections: sortedSubSections
                                                                            }
                                                                          : sec
                                                                      )
                                                              
                                                                    );
                                                                  }}
                                                            /> : null
                                                        }
                                                    </ul>
                                                </Grid>
                                            </Grid>
                                            {section.sub_sections.map((subSection, subSecIndex) =>
                                                <Paper key={`Section_${sectionIndex}_${subSecIndex}`} className='sub-section-blk'>
                                                    <div className='sub-section-head'>
                                                        <Grid container spacing={1} alignItems='center'>
                                                            <Grid item md={11}>
                                                                <TextField
                                                                    id={`sb_section_name_${section.id}_${subSection.id}`}
                                                                    fullWidth
                                                                    margin="none"
                                                                    InputLabelProps={{ shrink: true }}
                                                                    value={subSection.title}
                                                                    onChange={(e) => onFieldChange('title', e.target.value, sectionIndex, subSecIndex,)}
                                                                    variant='outlined'
                                                                />
                                                            </Grid>
                                                            <Grid item md={1}>
                                                                <ul className='list-inline' style={{ float: 'right' }}>
                                                                    <li className='list-inline-item'>
                                                                        <Tooltip title='Delete Sub-Section' arrow>
                                                                            <DeleteOutlineIcon style={{ cursor: 'pointer' }} onClick={() => setDeleteSection({ modal: true, type: 'Sub Section', data: { sectionIndex: sectionIndex, subIndex: subSecIndex } })} color='secondary' fontSize='medium' />
                                                                        </Tooltip>
                                                                    </li>
                                                                </ul>
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                    {expanded === `section_${sectionIndex}` ?
                                                        <div className='sub-section-body'>
                                                            <CkEditorText
                                                                htmlData={subSection.value}
                                                                onChangeData={(data) => onFieldChange('value', data, sectionIndex, subSecIndex)}
                                                            />
                                                        </div>
                                                        : null}
                                                </Paper>
                                            )}
                                            {!section.sub_sections.length ? <div style={{ textAlign: 'center', padding: '30px 0' }}>No sub-sections added yet!</div> : null}
                                        </Paper>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                        
                        )}
                        {!sectionData?.length &&
                            <div style={{ textAlign: 'center', padding: '50px 0px' }}>
                                <p>No section's added yet, click to add new section.</p>
                            </div>
                        }
                    </>
                    {sectionObj.modal ?
                        <AddSection
                            toggleModalFn={() => onToggleSection(false)}
                            sectionObj={sectionObj}
                            onFieldChange={onFieldChange}
                            onAddSection={onAddSection}
                        /> : null
                    }
                    {deleteSection.modal ?
                        <DeletePopUp
                            modal={deleteSection.modal}
                            toggleModalFn={() => setDeleteSection({ modal: false, type: '', data: null })}
                            title={`Delete ${deleteSection.type}`}
                            content={<h4>Are you sure you want to Delete?</h4>}
                            deleteRecordFn={() => handleDeleteSection()}
                        /> : null
                    }
                    {isLoading ? <PageLoader /> : null}
                </div>
            </div>
        </section>
    )
}
export default withRouter(SectionCheckList);